// extracted by mini-css-extract-plugin
export default {"consumer-medicaid-lead-item-questions-complete":"styles_consumer-medicaid-lead-item-questions-complete__wVxvk"};